import TranslatedText from "./translated-text";

export default TranslatedText;
